<template>
  <DiscordTechDesign variant="peek" />
</template>

<script>
import DiscordTechDesign from './DiscordTechDesign.vue';

export default {
  name: 'DiscordTech3',
  components: { DiscordTechDesign },
};
</script>
